/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CancelPhoneNumberVerificationRequest,
  MapString,
  Phone,
  PhoneNumberVerificationCallbackPayload,
  PhoneNumberVerificationRequest,
  PhoneNumberVerificationStatus,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "phone-caller";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Get the verification status of a phone number
   *
   * @tags numbers
   * @name GetNumberVerificationStatus
   * @request GET:/v1/{tenantId}/phone/verification/status/{userId}/{phone}
   */
  getNumberVerificationStatus = (tenantId: string, userId: string, phone: string, params: RequestParams = {}) =>
    this.request<
      PhoneNumberVerificationStatus,
      | Phone
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/phone/verification/status/${userId}/${phone}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getNumberVerificationStatus */
  getNumberVerificationStatusPathGetter = (tenantId: string, userId: string, phone: string) =>
    this.getServicePath(`/v1/${tenantId}/phone/verification/status/${userId}/${phone}`);

  /**
   * @description Start the verification process for a phone number
   *
   * @tags numbers
   * @name StartVerification
   * @request POST:/v1/{tenantId}/phone/verification
   */
  startVerification = (tenantId: string, data: PhoneNumberVerificationRequest, params: RequestParams = {}) =>
    this.request<
      PhoneNumberVerificationStatus,
      | Phone
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/phone/verification`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for startVerification */
  startVerificationPathGetter = (tenantId: string) => this.getServicePath(`/v1/${tenantId}/phone/verification`);

  /**
   * @description Cancel the verification process for a phone number
   *
   * @tags numbers
   * @name CancelVerification
   * @request POST:/v1/{tenantId}/phone/verification/cancel
   */
  cancelVerification = (tenantId: string, data: CancelPhoneNumberVerificationRequest, params: RequestParams = {}) =>
    this.request<
      object,
      | Phone
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/${tenantId}/phone/verification/cancel`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cancelVerification */
  cancelVerificationPathGetter = (tenantId: string) => this.getServicePath(`/v1/${tenantId}/phone/verification/cancel`);

  /**
   * @description Callback from the verification service (public, called by twilio)
   *
   * @tags numbers
   * @name VerificationCallback
   * @request POST:/v1/public/tenant/{tenantId}/phone/verification-callback
   */
  verificationCallback = (tenantId: string, data: PhoneNumberVerificationCallbackPayload, params: RequestParams = {}) =>
    this.request<
      object,
      | Phone
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/phone/verification-callback`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for verificationCallback */
  verificationCallbackPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/phone/verification-callback`);

  /**
   * @description Url for twilio to hit on connection between caller and their subaccount's number
   *
   * @tags calls
   * @name CallerConnection
   * @request POST:/v1/public/tenant/{tenantId}/call/caller/{internalCallId}
   */
  callerConnection = (tenantId: string, internalCallId: string, data: Phone, params: RequestParams = {}) =>
    this.request<
      Phone,
      | Phone
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/call/caller/${internalCallId}`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });

  /**
   * @description Returns string containing request path for callerConnection */
  callerConnectionPathGetter = (tenantId: string, internalCallId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/call/caller/${internalCallId}`);

  /**
   * @description Url for twilio to hit on connection caller with calleeg
   *
   * @tags calls
   * @name CalleeConnection
   * @request POST:/v1/public/tenant/{tenantId}/call/guest/{internalCallId}
   */
  calleeConnection = (tenantId: string, internalCallId: string, data: Phone, params: RequestParams = {}) =>
    this.request<
      Phone,
      | Phone
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/call/guest/${internalCallId}`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });

  /**
   * @description Returns string containing request path for calleeConnection */
  calleeConnectionPathGetter = (tenantId: string, internalCallId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/call/guest/${internalCallId}`);

  /**
   * @description Url for twilio to hit on call status change
   *
   * @tags calls
   * @name UpdateCallStatus
   * @request POST:/v1/public/tenant/{tenantId}/call/status/{internalCallId}
   */
  updateCallStatus = (tenantId: string, internalCallId: string, data: Phone, params: RequestParams = {}) =>
    this.request<
      object,
      | Phone
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/call/status/${internalCallId}`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateCallStatus */
  updateCallStatusPathGetter = (tenantId: string, internalCallId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/call/status/${internalCallId}`);

  /**
   * @description Url for twilio to hit on child call status change
   *
   * @tags calls
   * @name UpdateChildCallStatus
   * @request POST:/v1/public/tenant/{tenantId}/call/child/status/{internalCallId}
   */
  updateChildCallStatus = (tenantId: string, internalCallId: string, data: Phone, params: RequestParams = {}) =>
    this.request<
      object,
      | Phone
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/call/child/status/${internalCallId}`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateChildCallStatus */
  updateChildCallStatusPathGetter = (tenantId: string, internalCallId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/call/child/status/${internalCallId}`);
}
